import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { LOCAL_STORAGE_KEY } from '@/utils/constant';
import Footer from '@layout/footer';
import Header from '@layout/header';
import LanguageInfoModal from '@modal/modal_languageInfo';

const LayoutBody = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  & > div.main {
    flex: auto;
    width: 100%;
    max-width: 1000px;
    padding: 1rem 5rem;
    box-sizing: border-box;
    @media (max-width: 540px) {
      padding: 0 1rem;
      animation: none;
    }
  }
`;

const Layout = (props) => {
  const { i18n } = useTranslation();
  const { changeLanguage } = i18n;

  useEffect(() => {
    const savedLanguage = localStorage.getItem(LOCAL_STORAGE_KEY.LANGUAGE);
    savedLanguage && changeLanguage(savedLanguage);
  }, []);

  return (
    <LayoutBody>
      {!props.empty && <Header />}
      <div className="main">{props.children}</div>
      {!props.empty && <Footer />}
      {!props.empty && <LanguageInfoModal />}
    </LayoutBody>
  );
};

export default Layout;
